import { useState } from "react";
import {
  PATH_CONTACT,
  PATH_CONTACT_SECTION,
  PATH_HOME_SECTION,
  PATH_PORTFOLIO,
  PATH_PORTFOLIO_SECTION,
  PATH_SERVICES_SECTION,
} from "../../../utility/constants";
import Images from "../../../utility/imagePaths";
import Button from "../../common/buttons/button/Button";
import SectionHeader from "../sectionHeader/SectionHeader";
import "./HomeSection.css";
import AchievementCard from "../achievementCard/AchievementCard";
import { AchievnmentItemType } from "../../../utility/types/generaTypes";
import { useNavigate } from "react-router";

const HomeSection = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const ACHIEVENMENTS: AchievnmentItemType[] = [
    {
      label: "Projects Delivered",
      count: "10+",
    },
    {
      label: "Technologies Mastered",
      count: "10+",
    },
    {
      label: "Year Experience",
      count: "4+",
    },
    {
      label: "Support",
      count: "24/7",
    },
  ];
  return (
    <section
      id={PATH_HOME_SECTION}
      className="home_section"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.73)), url('https://cdn.pixabay.com/photo/2021/08/04/13/06/software-developer-6521720_1280.jpg')",
      }}
    >
      <div className="home_section_sub_container">
        <SectionHeader title={`🚀   Transforming Ideas into Digital Reality`} />
        <h1>
          Professional <span className="gradient_text"> Web & App </span>
          Development
        </h1>
        <p className="home_section_description">
          We craft exceptional digital experiences that drive growth, engage
          users, and bring your vision to life with cutting-edge technology.
        </p>
        <div className="home_section_btnContainer">
          <Button
            title="Start Your Project"
            onClickButton={() => navigate(PATH_CONTACT)}
            className="start_yourWork_btn"
            backgroundColor="linear-gradient(135deg, hsl(214 84% 56%),hsla(214, 77%, 57%, 1.00), hsl(263 70% 50%))"
            rightComponent={
              <img
                src={Images.SVG_ARROW_RIGHT_WHITE_ICON}
                alt="arrow white"
                className="arrow_right_white"
              />
            }
          />

          <Button
            title="Watch Our Work"
            onClickButton={() => navigate(PATH_PORTFOLIO)}
            className="watch_our_work_btn"
            backgroundColor="#FFFFFF"
            color="#000000"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            leftComponent={
              <img
                src={
                  isHovered
                    ? Images.SVG_PLAY_WHITE_ICON
                    : Images.SVG_PLAY_BLACK_ICON
                }
                alt="arrow white"
                className="play_icon"
              />
            }
          />
        </div>
        <div className="achievementCards_container">
          {ACHIEVENMENTS.map((achievenment, index) => (
            <AchievementCard
              key={"AchievementCard" + index}
              achivenment={achievenment}
            />
          ))}
        </div>
      </div>
      <a href={"#" + PATH_SERVICES_SECTION} className="bounceDiv">
        <div />
      </a>
    </section>
  );
};

export default HomeSection;
